<div class="container-fluid">
    <div class="row">

        <div class="col-6"></div>
        <div class="col-sm-12">
            <div class="p-3 card">
                <h3>{{ "ProsecutionResponses" | translate }}</h3>
                <div class="col-5 mb-2">

                    <button *ngIf="(caseDetials.stageId==100 || caseDetials.stageId==101) && caseservice.case && caseservice.case.sendToProsBySystem==false &&  (sharedService.hasCasePermission('P003',caseDetials.caseTypeId))" class="btn btn-primary" (click)="AddProsecution(AddProsecutionResponseModal);" href="javascript:void(0);">
                        <i class="fa fa-plus-circle"></i>
                        <span> {{'AddProsecutionResponse' | translate}} </span>
                    </button>

                </div>
                <table class="table table-striped mt-3">
                    <thead class="thead-dark">
                        <tr>
                            <th>{{ "ResponseStatus" | translate }}</th>
                            <th>{{ "Description" | translate }}</th>
                            <th>{{ "CourtName" | translate }}</th>
                            <th>{{ "OrderDateHJ" | translate }}</th>
                            <th>{{ "Attachments" | translate }}</th>
                            <th>{{ "Preview" | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let prosecutionResponsess of prosecutionResponsessArr">
                            <td>{{ prosecutionResponsess.prosecutionResponseTypeName }}</td>
                            <td>{{ prosecutionResponsess.description }}</td>
                            <td>{{ prosecutionResponsess.courtName }}</td>
                            <td>{{ prosecutionResponsess.decisiondate | toDateLarge }}</td>
                            <td>
                                <a (click)="AddAttachmentModal(AddAttachment,prosecutionResponsess.prosecutionResponseId,!((caseDetials.stageId==100 || caseDetials.stageId==101) && prosecutionResponsess.isManual && caseDetials && caseDetials.sendToProsBySystem==false &&  (sharedService.hasCasePermission('P003',caseDetials.caseTypeId) )) );"><i class="fa fa-files-o"></i></a>
                            </td>
                            <td>
                                <a (click)="previewProsecution(prosecutionResponsess.prosecutionResponseId,previewProsecutionResponseModal)">
                                    <i class="fa fa-eye"></i>
                                </a>
                                &nbsp;
                                &nbsp;
                                &nbsp;
                                <a 
                                   *ngIf="(caseDetials.stageId==100 || caseDetials.stageId==101) && prosecutionResponsess.isManual && caseDetials && caseDetials.sendToProsBySystem==false &&  (sharedService.hasCasePermission('P003',caseDetials.caseTypeId))" 
                                   (click)="deleteProsecution(confirmDelete,prosecutionResponsess.prosecutionResponseId)">
                                    <i class="fa fa-trash"></i>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
    </div>
</div>

<ng-template #previewProsecutionResponseModal let-modal>
    <div class="modal-header" style="justify-content: space-between">
        <div></div>
        <h4 class="modal-title" id="modal-basic-title">
            {{ "PreviewProsecutionResponse" | translate }}
        </h4>

        <i style="font-size: 20px"
           class="fa fa-close"
           (click)="modal.dismiss('Cross click')"></i>
    </div>
    <div class="modal-body">
        <div class="custom-form">
            <div class="col-12 offset-1">
                <div class="card p-3">
                    <div class="form-group row mt-3">
                        <div class="col-lg-12">
                            <label>{{ "ResponseStatus" | translate }}</label>
                            <span class="form-control" readonly>{{previewObj.prosecutionResponseTypeName}}&nbsp;</span>
                        </div>
                    </div>
                    <div class="form-group row mt-3">
                        <div class="col-lg-12">
                            <label>{{ "Description" | translate }}</label>
                            <span class="form-control" readonly>{{previewObj.description}}&nbsp;</span>
                        </div>
                    </div>
                    <div class="form-group row mt-3">
                        <div class="col-lg-6">
                            <label> {{'CourtName'|translate}}</label>
                            <span class="form-control" readonly>{{previewObj.courtName}}&nbsp;</span>
                        </div>
                        <div class="col-lg-6">
                            <label>{{'OrderDateHJ'|translate}} </label>
                            <span class="form-control" readonly>{{previewObj.decisiondate | toDateLarge }}&nbsp;</span>
                        </div>
                    </div>

                    <h4 class="mt-3">{{ "Attachments" | translate }}</h4>
                    <hr>
                    <app-general-attachment [ElementTypeId]="'10'" [loadDataFP]="loadfromparent"></app-general-attachment>

                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer row"
         style="justify-content: flex-end; padding: 1rem 2rem">
        <button type="button" class="btn btn-danger col-lg-2" (click)="modal.dismiss('Cross click')">
            {{ "Close" | translate }}
        </button>
    </div>
</ng-template>


<!-- ------------------------------------------------------------------------------------------ -->
<ng-template #AddProsecutionResponseModal let-modal>
    <div class="modal-header" style="justify-content: space-between">
        <div></div>
        <h4 class="modal-title" id="modal-basic-title">
            {{ "AddProsecutionResponse" | translate }}
        </h4>


        <i style="font-size: 20px"
           class="fa fa-close"
           (click)="modal.dismiss('Cross click')"></i>
    </div>
    <div class="modal-body">
        <div class="custom-form">
            <div class="col-12 offset-1">
                <div class="card p-3">
                    <div class="form-group row mt-3">
                        <div class="col-lg-6">
                            <label>{{ "ResponseStatus" | translate }}</label>
                            <span *ngIf="ProsecutionResponseTypeId.invalid" class="alert requriedfield">
                                <span *ngIf="ProsecutionResponseTypeId.errors?.required">
                                    *
                                </span>

                            </span>
                            <ng-select id="ProsecutionBranch"
                                       name="ProsecutionBranch"
                                       required
                                       #ProsecutionResponseTypeId="ngModel"
                                       class="form-control-select"
                                       [items]="prosectiontypesArr"
                                       bindLabel="text"
                                       bindValue="id"
                                       [(ngModel)]="prosecutionResponseTypeId"
                                       [ngModelOptions]="{ standalone: true }"
                                       placeholder="{{ 'ResponseStatus' | translate }}">
                            </ng-select>

                        </div>
                        <div class="col-lg-6">
                            <label>{{ "Description" | translate }}</label>
                            <span *ngIf="Description.invalid" class="alert requriedfield">
                                <span *ngIf="Description.errors?.required">
                                    *
                                </span>

                            </span>
                            <textarea required class="form-control" [(ngModel)]="description" #Description="ngModel"></textarea>
                        </div>
                    </div>
                    <div class="form-group row mt-3">
                        <div class="col-lg-6">
                            <label> {{'CourtName'|translate}}</label>
                            <input type="text" class="form-control" [(ngModel)]="courtName" />
                        </div>
                        <div class="col-lg-6">
                            <label>{{'OrderDateHJ'|translate}} </label>


                            <datepicker [(maxHijri)]="currentDate" [(maxGreg)]="currentDate"
                                        (selectedDateChange)="SelectedDateChangeExcel($event)" [selectedDateType]="2"></datepicker>

                        </div>
                    </div>
                    <div class="row m-2 col-12">
                        <div class="col-4"></div>
                        <div class="col-4">
                            <button [disabled]="ProsecutionResponseTypeId.invalid || Description.invalid" *ngIf="isInsert" type="button" class="btn btn-primary" (click)="onCreateRecord()">
                                {{ "Save" | translate }}
                            </button>

                        </div>
                    </div>
                    <h4 class="mt-3" *ngIf="ProsecutionResponseId">{{ "Attachments" | translate }}</h4>
                    <hr>
                    <app-general-attachment [ElementTypeId]="'9'" [loadDataFP]="loadfromparent" *ngIf="ProsecutionResponseId!=null"></app-general-attachment>

                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer row"
         style="justify-content: flex-end; padding: 1rem 2rem">
        <button type="button" class="btn btn-danger col-lg-2" (click)="modal.dismiss('Cross click')">
            {{ "Close" | translate }}
        </button>
    </div>
</ng-template>



<ng-template #AddAttachment let-modal>
    <div class="modal-header" style="justify-content: center">
        <h4 class="modal-title" id="modal-basic-title">
            {{'Attachments'|translate}}
        </h4>
    </div>
    <div class="modal-body text-center">
        <app-general-attachment [ElementTypeId]="'10'" [loadDataFP]="loadfromparent"></app-general-attachment>

    </div>
    <div class="modal-footer">

        <button type="button" class="btn btn-primary" (click)="modal.dismiss('Cross click')">
            {{ "Close" | translate }}
        </button>
    </div>
</ng-template>





<ng-template #confirmDelete let-modal>
    <div class="modal-header" style="justify-content: center">
        <h5 class="modal-title text-danger" id="modal-basic-title">
            <b>
                <app-feather-icons [icon]="'alert-triangle'" style="position:relative; top:4px;"></app-feather-icons> {{
                "ConfirmDeleteOperation" | translate
                }}
            </b>
        </h5>
    </div>
    <div class="modal-body text-center">
        <p class="alert fs-6">{{ "SelectedRecordwillbeDeleted" | translate }}</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="onDelete(modal)">
            {{ "Yes" | translate }}
        </button>
        <button type="button" class="btn btn-primary" (click)="modal.dismiss('Cross click')">
            {{ "No" | translate }}
        </button>
    </div>
</ng-template>



